export var name = 'locale';
